import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconForkCode: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="fork-code"><circle cx="6" cy="6" r="2.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="18" r="2.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="18" cy="6" r="2.25" stroke="currentColor" strokeWidth="1.5"/><path d="M6 8.25V12H12V15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18 8.25V12H12V15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconForkCode;
